import { _, ts } from '_core';

// prepareNameCountData
export const transform = (
  data: ts.types.widgets.TableData,
  isBasket: boolean,
  isEtf: boolean,
  hasBenchmark: boolean,
  isLongOnly: boolean,
  showTargetWeight?: boolean
) => {
  if (_.isEmpty(data)) {
    return [];
  }

  const newData = data.map((item) => {
    const newItem = { ...item } as ts.types.widgets.TableData[number];
    if (newItem['universe_count']) {
      newItem['Universe Count'] = newItem['universe_count'];
    }
    if (!isLongOnly && newItem['short_count']) {
      newItem['Short Count'] = newItem['short_count'];
    }
    if (newItem['long_count']) {
      newItem['Long Count'] = newItem['long_count'];
    }
    if (newItem['portfolio_count']) {
      newItem['Portfolio Count'] = newItem['portfolio_count'];
    }
    if (isEtf) return newItem;

    const shouldShowBenchmarkData = isBasket ? showTargetWeight : true;
    if (hasBenchmark && shouldShowBenchmarkData) {
      if (newItem['benchmark_count']) {
        newItem[isBasket ? 'Target Count' : 'Benchmark Count'] = newItem['benchmark_count'];
      }
    }

    delete newItem['short_count'];
    delete newItem['long_count'];
    delete newItem['universe_count'];
    delete newItem['benchmark_count'];
    delete newItem['portfolio_count'];

    return newItem;
  });

  return newData;
};
